import React from 'react';
import { translate } from 'react-i18next';
import { compose, setDisplayName } from 'recompose';

import TranslationContext from './translation-context';

/* eslint-disable react/prop-types */

export default (namespace, options = {}) => (WrappedComponent) => {
  const Translate = (props) => {
    const { t, tReady, ...rest } = props;

    return (
      <TranslationContext.Consumer>
        {context => (
          <WrappedComponent
            {...rest}
            t={(key, opts = {}) => t(key, { context, ...opts })}
          />
        )}
      </TranslationContext.Consumer>
    );
  };

  return compose(
    setDisplayName(WrappedComponent.displayName),
    translate(namespace, options)
  )(Translate);
};
